import React, {Component} from 'react';
import { FieldGroups } from "../FieldGroups";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import {FieldGroup} from "../FieldGroup";
import {addSubField} from "../../../../../store/actions/subFields";
import connect from "react-redux/es/connect/connect";
import ParametersNotice from "../../Parameters/ParametersNotice";

class QueryBuilder extends Component {
  render() {

    const { settings } = this.props;

    return (
      <FieldGroupContext.Consumer>

        {({ endpointId, endpoint, currentItem, action }) => (
            <React.Fragment>
              {settings.endpoints[endpointId].customSQLQuery[currentItem].basic.map(
                (field, index) => <FieldGroup key={index} label={field.label} fields={field.fields} group="basic" groupId={index} currentItem={currentItem} action={action}/>
              )}
            </React.Fragment>
        )}

      </FieldGroupContext.Consumer>
    );
  }
};

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
  addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(QueryBuilder);
